import { useContext } from 'react';

import { EnvironmentContext, EnvironmentContextType } from '@contexts/environment-context';

export const useEnvironment = (): EnvironmentContextType => {
    const context = useContext(EnvironmentContext);
    if (context === undefined) {
        throw new Error('useEnvironment must be used within an EnvironmentProvider');
    }
    return context;
};